import { render, staticRenderFns } from "./PanelDetailsPage.vue?vue&type=template&id=0596aa73&scoped=true"
import script from "./PanelDetailsPage.vue?vue&type=script&lang=js"
export * from "./PanelDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./PanelDetailsPage.vue?vue&type=style&index=0&id=0596aa73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596aa73",
  null
  
)

export default component.exports